const maintenanceButtonEquip = {
  true: 'Return from',
  false: 'Send to',
  label: 'Maintenance'
};

export default maintenanceButtonEquip;
